import type { QueryClient } from "@tanstack/react-query";
import { patchCachedTenant } from "@/lib/auth/profile-cache";

/**
 * Record in the cached profile that this tenant now has had a site (task
 * 495), so `tenant.firstSiteCreatedAt` agrees with the sites list for the
 * rest of the profile's five-minute `staleTime`. The onboarding layout reads
 * it to send an onboarded tenant to the dashboard. Written only where the
 * cache says null, so it never moves a date the API already gave.
 */
export async function noteTenantHasHadSite(
  queryClient: QueryClient,
  siteCreatedAt: string,
): Promise<void> {
  await patchCachedTenant(queryClient, (tenant) =>
    tenant.firstSiteCreatedAt === null
      ? { ...tenant, firstSiteCreatedAt: siteCreatedAt }
      : tenant,
  );
}
